import { render } from "./testing-2.vue?vue&type=template&id=44e7fade&scoped=true"
import script from "./testing-2.vue?vue&type=script&lang=js"
export * from "./testing-2.vue?vue&type=script&lang=js"

import "./testing-2.vue?vue&type=style&index=0&id=44e7fade&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e7fade"]])

export default __exports__